module.exports = "/_next/static/images/row2-4-8325dcf8ca4badab50c202bef43a1d9a.png";